module.exports = __webpack_public_path__ + "img/working.8afd1f2d.webp";